import React from 'react';
import { FormattedMessage } from 'react-intl';
import { makeStyles } from '@material-ui/core/styles';

import SectionEyebrow from '../../MyComponents/LandingSections/SectionEyebrow';
import useAboutStyles from './aboutStyles';
import { CARD } from '../Home/HomeDashboard/dashboardStyles';
import { REDESIGN_COLORS, REDESIGN_FONTS, REDESIGN_TINTS } from '../../constants';

const IMG = '/static/asset/img/';

const PEOPLE = [
    { key: 'founder', roleId: 'aboutUs.team.founder', nameId: 'aboutUs.team.founder.name', textId: 'aboutUs.team.founder.description', img: `${IMG}MariusMazilu.png`, tint: REDESIGN_TINTS.mint },
    { key: 'c1', roleId: 'aboutUs.team.colaborator1', nameId: 'aboutUs.team.colaborator1.name', textId: 'aboutUs.team.colaborator1.description', img: `${IMG}MariusLobaza.png`, tint: REDESIGN_TINTS.peach },
    { key: 'c2', roleId: 'aboutUs.team.colaborator2', nameId: 'aboutUs.team.colaborator2.name', textId: 'aboutUs.team.colaborator2.description', img: `${IMG}DanielaRezmive.png`, tint: REDESIGN_TINTS.sky },
    {
        key: 'c3',
        roleId: 'aboutUs.team.colaborator3',
        nameId: 'aboutUs.team.colaborator3.name',
        textId: 'aboutUs.team.colaborator3.description',
        img: 'https://victorysquarepartners.com/wp-content/uploads/2022/06/VSP-Logo-SVG.svg',
        tint: REDESIGN_TINTS.linen,
        logo: true,
    },
];

const useStyles = makeStyles(() => ({
    grid: {
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fill, minmax(min(100%, 240px), 1fr))',
        gap: '18px',
    },
    card: {
        ...CARD,
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden',
    },
    mat: {
        display: 'grid',
        placeItems: 'center',
        boxSizing: 'border-box',
        height: '200px',
        padding: '20px',
    },
    photo: {
        width: '150px',
        height: '150px',
        objectFit: 'cover',
        borderRadius: '50%',
        border: `4px solid ${REDESIGN_COLORS.white}`,
        boxShadow: '0 12px 32px rgba(6, 63, 69, 0.12)',
    },
    logo: {
        maxWidth: '100%',
        maxHeight: '100%',
        objectFit: 'contain',
    },
    body: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        gap: '8px',
        padding: '18px 20px 22px',
    },
    name: {
        margin: 0,
        fontSize: '1.15rem',
        lineHeight: 1.2,
        letterSpacing: '-0.02em',
        fontWeight: REDESIGN_FONTS.weightHeading,
        color: REDESIGN_COLORS.dark,
    },
    text: {
        margin: 0,
        color: REDESIGN_COLORS.body,
        fontSize: '0.9rem',
        lineHeight: 1.55,
    },
}));

const AboutTeam = () => {
    const about = useAboutStyles();
    const classes = useStyles();

    return (
        <>
            <div className={about.head}>
                <h2 className={about.h2}>
                    <FormattedMessage id="aboutUs.team.button" />
                </h2>
                <p className={about.lead}>
                    <FormattedMessage id="redesign.about.team.lead" />
                </p>
            </div>

            <div className={classes.grid}>
                {PEOPLE.map((person) => (
                    <article key={person.key} className={classes.card}>
                        <div className={classes.mat} style={{ background: person.tint }}>
                            <img
                                src={person.img}
                                alt=""
                                loading="lazy"
                                decoding="async"
                                className={person.logo ? classes.logo : classes.photo}
                            />
                        </div>
                        <div className={classes.body}>
                            <SectionEyebrow variant="card">
                                <FormattedMessage id={person.roleId} />
                            </SectionEyebrow>
                            <h3 className={classes.name}>
                                <FormattedMessage id={person.nameId} />
                            </h3>
                            <p className={classes.text}>
                                <FormattedMessage id={person.textId} />
                            </p>
                        </div>
                    </article>
                ))}
            </div>
        </>
    );
};

export default AboutTeam;
